import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import {
	badgeCouponStripSX,
	buttonCouponStripSX,
	containerCouponStripSX,
	descriptionCouponStripSX,
	textCouponStripSX,
	titleCouponStripSX,
} from '@/components/blocks/DpLibrary/DpCouponStrip/styles';
import { combineSX } from '@/utils/combineSX';
import { Box, SxProps, Theme, Typography } from '@mui/material';
import { MouseEvent } from 'react';
import { UrlObject } from 'url';

type DpCouponStripProps = {
	name?: string;
	discount: string | number;
	description?: string;
	expiration?: string;
	button?: string;
	href?: string | UrlObject;
	onClick?: (e: MouseEvent<HTMLElement>) => void;
	sx?: SxProps<Theme>;
};

/** Franja compacta del cupón de recompra debajo del banner principal del home. */
export const DpCouponStrip = ({
	name,
	discount,
	description,
	expiration,
	button = 'Ver mi selección',
	href,
	onClick,
	sx,
}: DpCouponStripProps) => {
	const details = [description, expiration ? `Vence en ${expiration}` : undefined]
		.filter(Boolean)
		.join(' · ');

	return (
		<Box sx={combineSX([containerCouponStripSX, ...(Array.isArray(sx) ? sx : [sx])])}>
			<Box sx={badgeCouponStripSX}>{discount}</Box>
			<Box sx={textCouponStripSX}>
				<Typography sx={titleCouponStripSX}>
					{`${name ? `${name}, tu` : 'Tu'} ${discount} OFF sigue activo`}
				</Typography>
				{details ? <Typography sx={descriptionCouponStripSX}>{details}</Typography> : null}
			</Box>
			<DpButton text={`${button} →`} href={href} onClick={onClick} sx={buttonCouponStripSX} />
		</Box>
	);
};
